// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"428":"de1c3549","557":"1fa51a4b","801":"6cdfdf8b"}[chunkId] + ".chunk.css";
};